module.exports = __webpack_public_path__ + "img/profil.62cd81d8.svg";